import React, { useState } from 'react'
import { useHistory } from 'react-router'
import { MdDeleteForever, MdEdit, MdVisibility } from "react-icons/md"
// import Select from 'react-select';
// import { toast } from 'react-toastify'
// import locationServices from '../../../Services/locationServices'
import { ChangeStatus } from '../../../Components'
// import ReactPaginate from 'react-paginate'
// import Loader from '../../../Components/Loader';
// import { Badge } from 'react-bootstrap-v5';

export const WarehouseUpdate = () => {


    const history = useHistory()

    const [deleteModalOpen, setDeleteModalOpen] = useState(false)
    // const [pickUpList, setPckUpList] = useState([1, 2, 3, 4, 5]) 

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div>
                            {/* <div>

                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            width: '200px',
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    placeholder="Pickup Status..."
                                // value={countryValue}
                                // onChange={(e) => onSelectCountry(e)}
                                // options={countryList}
                                />
                            </div>
                            <div>
                                <button
                                    className="btn btn-primary btn-sm waves-effect waves-light"
                                >
                                    <MdSearch
                                        className="pointer"
                                        size="25px"
                                    // onClick={() => setDeleteModalOpen(item)}
                                    />
                                </button>
                            </div>
                            {/* <button className="btn btn-primary w-sm waves-effect waves-light"
                                onClick={() => history.push('/add-pick-up')}
                            >Add PickUp
                            </button> */}
                            <button className="btn btn-primary w-sm waves-effect waves-light"
                                onClick={() => history.push('/add-warehouse-update')}
                            >Add Warehouse
                            </button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th rowSpan="2"> S no.</th>
                                        <th rowSpan="2"> Job No.</th>
                                        <th rowSpan="2"> Customer Name</th>
                                        <th rowSpan="2"> Customer Contact No.</th>
                                        <th rowSpan="2"> Retailer Contact No.</th>
                                        <th colspan="3" className="splitting_tr_up">Cargo Details</th>
                                        <th rowSpan="2" className="text-center"> Action</th>
                                    </tr>

                                    <tr className="splittingCol">
                                        <td >No. of Packages</td>
                                        <td >Total <br /> Volume</td>
                                        <td >Total Weight</td>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td>999</td>
                                        <td>loram</td>
                                        <td>9847362718</td>
                                        <td>9847362718</td>
                                        <td>125</td>
                                        <td>1.5<sup>3</sup></td>
                                        <td>568kg</td>
                                        <td>
                                            <MdEdit
                                                className="pointer"
                                                onClick={() => history.push('edit-warehouse-update')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                            <MdDeleteForever
                                                className="pointer"
                                                color="red"
                                                size="25px"
                                            />
                                            <MdVisibility
                                                className="pointer"
                                                onClick={() => history.push('warehouse-update-details')}
                                                color="#0323fe"
                                                size="25px"
                                            />
                                        </td>
                                    </tr>




                                </tbody>
                            </table>

                        </div>
                    </div>
                    {Boolean(deleteModalOpen) &&
                        <ChangeStatus
                            isOpen={Boolean(deleteModalOpen)}
                            title='Delete'
                            message={`Are you sure want to delete?`}
                            onSubmitEvent={() => setDeleteModalOpen(false)}
                            handleClose={() => setDeleteModalOpen(false)}
                        />
                    }
                </div>

            </div>
        </div>
    )
}


